import { IAnalyticsController } from "./IAnalyticsController";

export class MockAnalyticsController implements IAnalyticsController
{
	constructor()
	{
		console.log("MockAnalyticsController");
	}

	async initialize(): Promise<boolean> {
		console.log("MockAnalyticsController::initialized");
		return true;
	}

	logEvent(eventName:string, eventParams?:{[key: string]: any}):void
	{
		console.log(`logEvent(${eventName})`, eventParams?JSON.stringify(eventParams):'No params');
	}
}